export const BANK = {
  account: "Vaya Holidays Turizm A.Ş.",
  bank: "Placeholder Bank — update before going live",
  iban: "TR00 0000 0000 0000 0000 0000 00",
  swift: "XXXXXXXX",
};
